var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RoutinesForm',{attrs:{"routinesProp":_vm.routines,"subjectPermission":_vm.subjectPermission},on:{"save-routine":_vm.saveConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }